import { Pipe, PipeTransform } from '@angular/core';
import { enumWeightUnit } from '@data-layer/enums/common';

@Pipe({
  name: 'weightUnit',
})
export class WeightUnitPipe implements PipeTransform {
  public transform(value: enumWeightUnit): string {
    return 'WEIGHT_UNIT.' + enumWeightUnit[value];
  }
}
